export default __webpack_public_path__ + "images/textures/blue-gradient-texture-bold.jpg";